import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import ja from "../Data/ja";
import en from "../Data/en";

export const LanguageContext = createContext();
export const useLanguage = () => useContext(LanguageContext);

export default function LanguageProvider({ children }) {
  const [language, setLanguage] = useState();

  // testcode
  //localStorage.setItem("meta-assets-langage", "en");
  // testcode

  let localStorageLang = localStorage.getItem("meta-assets-langage");
  if (localStorageLang == undefined || localStorageLang == "") {
    localStorageLang = "en";
    setLanguage(en);
    localStorage.setItem("meta-assets-langage", "en");
  } else if (language == undefined || language.language != localStorageLang) {
    if (localStorageLang == "en") {
      setLanguage(en);
      localStorage.setItem("meta-assets-langage", "en");
    } else if (localStorageLang == "ja") {
      setLanguage(ja);
      localStorage.setItem("meta-assets-langage", "ja");
    }
  } else if (language.language == localStorageLang) {
    console.log("language set complete");
  }

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

LanguageProvider.propTypes = {
  children: PropTypes.any,
};
